<template lang="pug">
	.lexicon--editor-item.flex-row.space-medium
		.flex-col.space.flex-1
			.flex-row.space
				.font-tiny.upper.grey {{$tCaption('Grapheme')}}
				.adt-button.rounded.clickable.hoverlable.flex-row.align-center.center(v-if="!isAlias", @click="addTag('grapheme')")
					fas(icon="plus" size="2xs")
			.flex-row.space.align-center(v-for="(grapheme, idx) in graphemes")
				DxTextBox.small.flex-1(:value="grapheme.textContent", stylingMode="filled", @value-changed="e => valueChanged(grapheme, e.value)")
				.adt-button.rounded.clickable.hoverlable.flex-row.align-center.center(v-if="!isAlias", @click="removeItem(grapheme, graphemes, idx)")
					fas(icon="times" size="2xs")
		.flex-col.space.flex-1(v-if="isAlias")
			.flex-row.space
				.font-tiny.upper.grey {{$tCaption('Alias')}}
			.flex-row.space.align-center
				DxTextBox.small.flex-1(v-for="alias in aliases", :value="alias.textContent", stylingMode="filled", @value-changed="e => valueChanged(alias, e.value)")
				.adt-button.rounded.clickable.hoverlable.flex-row.align-center.center(v-if="!isAlias", @click="addTag('phoneme')")
					fas(icon="plus" size="2xs")
		.flex-col.space.flex-1(v-if="!isAlias")
			.flex-row.space
				.font-tiny.upper.grey {{$tCaption('Phoneme')}}
				.adt-button.rounded.clickable.hoverlable.flex-row.align-center.center(@click="addTag('phoneme')")
					fas(icon="plus" size="2xs")
			.flex-row.space.align-center(v-for="(phoneme, idx) in phonemes")
				DxTextBox.small.flex-1(:value="phoneme.textContent", stylingMode="filled", @value-changed="e => valueChanged(phoneme, e.value)")
				.adt-button.rounded.clickable.hoverlable.flex-row.align-center.center(v-if="!isAlias", @click="removeItem(phoneme, phonemes, idx)")
					fas(icon="times" size="2xs")
		DxButton(stylingMode="text", icon="fas fa-times", @click="$emit('remove')")
</template>

<script>
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'lexicon.LexiconEditor',
		name: 'lexicon--editor',
		props: ['lexicon', 'lexeme'],
		components: { DxTextBox, DxButton },
		data() {
			return {
				graphemes: [],
				aliases: [],
				phonemes: []
			};
		},
		computed: {
			isAlias() {
				return this.aliases.length > 0;
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.lexiconEditorItem = this;
			this.calcNodes();	
		},
		methods: {
			removeItem(item, array, indx) {
				item.remove();
				array.splice(indx, 1);
				this.$emit('change');
			},
			calcNodes() {
				this.graphemes = this.getItems('grapheme');
				this.aliases = this.getItems('alias');
				this.phonemes = this.getItems('phoneme');
			},
			valueChanged(node, val) {
				node.textContent = val;
				this.$emit('update:lexeme', this.lexeme);
				this.$emit('change');
			},
			getItems(tag) {
				var items = this.lexeme?.querySelectorAll(tag) || [];
				var result = [];
				for(var i = 0; i < items.length;i++) {
					result.push(items[i]);
					if (__DEBUG__)
						console.debug(tag, items[i].textContent);
				}
				return result;
			},
			addTag(tag) {
				const newTag = document.createElement(tag);
				this.lexeme.appendChild(newTag);
				const array = tag === 'grapheme' ? this.graphemes : (tag === 'alias' ? this.aliases : this.phonemes);
				array.push(newTag);
				this.$emit('update:lexeme', this.lexeme);
				this.$emit('change');
			}
		}
	};
</script>
<style lang='scss'>
	.lexicon--editor-item {
		padding: 10px;
		background: rgba(0,0,0,0.03);
		border-radius: 4px;
	}
</style>
